// app/javascript/packs/application.js
// Se eliminaron las líneas obsoletas "//= require"

// Importa el JavaScript de Bootstrap desde node_modules
import * as bootstrap from 'bootstrap';
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import App from 'app';
import '../sticky_tables';
import './order_price_editor';
import './price_editor_final';
import './invoice_amount_highlighter';
import './order_price_highlighter';
import './user_manual';
import './breadcrumb_tooltips';
import './payouts_modal';

// Hacer Bootstrap disponible globalmente para scripts inline
window.bootstrap = bootstrap;

Rails.start()
window.Rails=Rails;
ActiveStorage.start()

window.onload=function(){
  // Renderizar Vue en el elemento #app
  const appElement = document.querySelector('#app');
  
  if (appElement) {
    window.app = App.UI.render('#app');
  }
}